/*
 * Filename: d:\projects\AutoFiFront\src\Content\Modals\ModalCta\ModalCta.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, February 8th 2023, 12:55:34 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import { MouseEventHandler, useState } from "react";
import MyModal from "Content/Modals/MyModal";
import translator from "MultiLanguage/TranslationWrapper";
import styles from "Content/Modals/ModalCta/ModalCta.module.css";
import LinkStyled from "Theme/Component/LinkStyled";
import PhoneSVG from "Content/SVG/OtherSVG/PhoneSVG";
import MailSVG from "Content/SVG/OtherSVG/MailSVG";
import { getThemeColor } from "Utils/ThemeColor";

type ModalCtaProps = {
    show: boolean,
    onClose: MouseEventHandler<HTMLDivElement>,
    closeModal: MouseEventHandler,
    themeColor: string,
};

function ModalCta (props: ModalCtaProps) {
    const [telReveal, setTelReveal] = useState(false);
    const [mailReveal, setMailReveal] = useState(false);
    const themeColor = getThemeColor(props.themeColor);

    return (
        <MyModal closeModal={props.closeModal} show={props.show} onClose={props.onClose} addCloseCross={true} footer={(()=>{return (<></>)})()} title={translator.decode("call_to_action.selectContact")} className={styles.modalCtaStyle} themeColor={props.themeColor}>
            <div className={`${styles.modalCtaHolder} ${styles.paddingLeft}`}>
                <div className={`${styles.modalItemsFlex} pl-5`}>
                    <label htmlFor="telto"> {translator.decode("call_to_action.telto")} </label>
                    <LinkStyled bgColor={props.themeColor} id="telto" href="tel:">
                        <button className={`${styles.iconButton}`} onClick={()=>{setTelReveal(true)}}>
                            <PhoneSVG width="100%" fill={themeColor}/>
                        </button>
                    </LinkStyled>
                    <p id="tel" className={`${!telReveal ? styles.hiddenData : ""}`}>{translator.decode("call_to_action.tel")}</p>
                </div>
                <div className={`${styles.modalItemsFlex}`}>
                    <label htmlFor="mailto"> {translator.decode("call_to_action.mailto")} </label>
                    <LinkStyled bgColor={props.themeColor} id="mailto" href="mailto:contact@mobyfleet.fr">
                        <button className={`${styles.iconButton}`} onClick={()=>{setMailReveal(true)}}>
                            <MailSVG width="100%" fill={themeColor}/>
                        </button>
                    </LinkStyled>
                    <p id="mail" className={`${!mailReveal ? styles.hiddenData : ""}`}>{translator.decode("call_to_action.mail")}</p>
                </div>
            </div>
        </MyModal>
    );
}

export default ModalCta;
